import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import './CatalogDropdown.css';

const CatalogDropdown = ({ onCategoryClick }) => {
    const { data: categories, loading, error } = useSelector(state => state.categories.all);

    // Если загрузка завершена и категорий нет или произошла ошибка - ничего не показываем
    if (!loading && (!categories || categories.length === 0 || error)) {
        return null;
    }

    return ( 
        <>
            {loading ? (
                <div className="catalog-dropdown-loading">
                    <LoadingSpinner message="Загрузка категорий..." size="sm"/>
                </div>
            ) : (
                <div className="catalog-dropdown shadow-sm">
                    <div className="categories-container">
                        {categories && categories.map((category, index) => (
                            <Link 
                                key={index}
                                to={`/catalog/${encodeURIComponent(category.name)}`}
                                className="category-item"
                                onClick={onCategoryClick}
                            >
                                {category.title}
                            </Link>
                        ))}
                    </div> 
                </div>
            )}
        </>
    );
};

export default CatalogDropdown;